import script from "./CommentTypes.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentTypes.vue?vue&type=script&setup=true&lang=ts"

import "./CommentTypes.vue?vue&type=style&index=0&id=27a35bcf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a35bcf"]])

export default __exports__